import React from 'react';
import { FormControl, FormLabel, Select } from '@chakra-ui/react';
import TextError from '../common/TextError';
import Required from '../common/Required';

export default function CustomSelect(props) {
    const { formik, label, name, id, required, options=[], ...rest } = props;

    return (
        <FormControl id={id}>
            <FormLabel>
                {label}
                {required ? <Required /> : ''}
            </FormLabel>
            <Select
                name={name}
                onChange={formik.handleChange} 
                onBlur={formik.handleBlur} 
                value={formik.values[name]} 
                {...rest}
            >
                {options.map((option, key) => (
                    <option key={key} value={option.key}>{option.value}</option>
                ))}
            </Select>
            {formik.touched[name] && formik.errors[name] &&
                <TextError val={formik.errors[name]} />
            }
        </FormControl>
    )
}